<template>
  <div>
    <h1
      class="text-bold full-width"
      :class="{
        'text-center': textCenter,
        [`text-${textSize}`]: true,
        [textColorClass]: !!textColorClass,
        'text-primary': !textColorClass,
        'q-mb-md q-mt-lg': !dense,
        'q-my-sm': dense
      }"
    >
      {{ findMovieBySlug.name }}

      <rated
        v-if="findMovieBySlug.rating"
        v-bind="$attrs"
        class="q-mx-none"
      />
    </h1>
    <div
      :class="{
        'text-center': textCenter,
        [textColorClass]: !!textColorClass,
        'q-my-md': !dense
      }"
    >
      <span v-if="findMovieBySlug.dateOfFirstShowing && findMovieBySlug.dateOfFirstShowing.isDate() && !findMovieBySlug.hideDateOfFirstShowing">
        <q-badge
          class="bg-transparent"
          :class="badgeClasses"
          style="font-size: 0.9rem;"
          :outline="outlined"
          :label="dateOfFirstShowingLabel"
        />&nbsp;&middot;&nbsp;
      </span>
      <span v-if="findMovieBySlug.genre">
        <q-badge
          class="bg-transparent"
          :class="badgeClasses"
          style="font-size: 0.9rem;"
          :outline="outlined"
          :label="findMovieBySlug.genre"
        />&nbsp;&middot;&nbsp;</span>
      <span v-if="findMovieBySlug.duration">
        <q-badge
          class="bg-transparent"
          :class="badgeClasses"
          style="font-size: 0.9rem;"
          :outline="outlined"
          :label="findMovieBySlug.formattedDuration"
        /></span>
    </div>
  </div>
</template>

<script>
import MovieSlugMixin from 'src/modules/consumer/components/mixins/MovieSlugMixin'
import Rated from 'src/modules/consumer/components/Rated'
export default {
  name: 'MovieHeading',
  components: {
    Rated
  },
  mixins: [MovieSlugMixin],
  props: {
    textColorClass: {
      type: String,
      default: undefined
    },
    textCenter: {
      type: Boolean,
      default: false
    },
    textSize: {
      type: String,
      default: 'h4'
    },
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeClasses () {
      const classes = []
      if (this.textColorClass) {
        classes.push(this.textColorClass)
      } else {
        classes.push('text-dark')
      }
      if (!this.outlined) {
        classes.push('q-px-none')
      }
      return classes.join(' ')
    },
    dateOfFirstShowingLabel () {
      const today = new Date()
      const isReleased = today >= this.findMovieBySlug?.dateOfFirstShowing
      return isReleased
        ? `${this.$t('movie.releaseDate')} ${this.$d(this.findMovieBySlug.dateOfFirstShowing, 'longDate')}`
        : `${this.$t('time.starts')} ${this.$d(this.findMovieBySlug.dateOfFirstShowing, 'longDate')}`
    }
  }
}
</script>
